import React from "react";

import { Row, Col, Card } from "react-bootstrap";
function Overview(props) {
  return (
    <div>
      <Row>
        <Col>
          <Row>
            <Col>
              <h4>What your package includes?</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <li> Convalis non sed nunc urna jhedgh</li>
              <li> Convalis non sed nunc urna jhedgh</li>
              <li> Convalis non sed nunc urna jhedgh</li>
              <li> Convalis non sed nunc urna jhedgh</li>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <h4>What your package includes?</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <li> Convalis non sed nunc urna jhedgh</li>
              <li> Convalis non sed nunc urna jhedgh</li>
              <li> Convalis non sed nunc urna jhedgh</li>
              <li> Convalis non sed nunc urna jhedgh</li>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default Overview;
